import { useEffect, useState, useRef } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { api, rawAxios } from '../api';
import { embedDashboard } from "@superset-ui/embedded-sdk";

// Sub-componente para manejar el renderizado del SDK
const SupersetEmbedded = ({ uuid }) => {
  const dashboardRef = useRef(null);

  useEffect(() => {
    const loadDashboard = async () => {
      if (dashboardRef.current && uuid && uuid !== 'null') {
        await embedDashboard({
          id: uuid, // El UUID del dashboard
          supersetDomain: "https://reportes.sitesas.com",
          mountPoint: dashboardRef.current,
          fetchGuestToken: async () => {
            const response = await rawAxios.get(`/api/superset/token?uuid=${uuid}`);
            return response.data.token;
          },
          dashboardUiConfig: {
            hideTitle: true,
            hideChartControls: false,
          },
        });

        const iframe = dashboardRef.current.querySelector('iframe');
        if (iframe) {
          iframe.style.width = '100%';
          iframe.style.height = '100%';
          iframe.style.border = 'none';
        }
      }
    };

    loadDashboard();
  }, [uuid]);

  return <div ref={dashboardRef}
      style={{ 
        width: '100%', 
        height: '85vh', // 85% de la altura de la ventana
        minHeight: '600px',
        overflow: 'hidden'
      }} />;
};

const Home = () => {
  const reporte_principal = localStorage.getItem('url_principal');
  const reporte_secundario = localStorage.getItem('url_secundario');
  const [activeTab, setActiveTab] = useState('principal');    
  
   useEffect(() => {
    // Llamada que fuerza a validar la conexión
    api.get('/servicios')
      .catch(err => {
        console.error('Error validando conexión:', err);
      });
  }, []);

  return (
    <div className="mt-4">
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="mb-3"
        fill
      >
        <Tab eventKey="principal" title="Monitoreo de la sala en tiempo real">
          {reporte_principal !== 'null' ? (
            <SupersetEmbedded uuid={reporte_principal} />
          ) : (
            <div style={{ width: '100%', textAlign: 'center', padding: '50px' }}>
              Este reporte no está configurado. Por favor comuníquese con soporte...
            </div>
          )}
        </Tab>

        <Tab eventKey="secundario" title="Histórico de atención en Sala">
          {reporte_secundario !== 'null' ? (
            <SupersetEmbedded uuid={reporte_secundario} />
          ) : (
            <div style={{ width: '100%', textAlign: 'center', padding: '50px' }}>
              Este reporte no está configurado. Por favor comuníquese con soporte...
            </div>
          )}
        </Tab>
      </Tabs>
    </div>
  );

  // return (
  //   <div className="mt-4">
  //     <Tabs
  //       activeKey={activeTab}
  //       onSelect={(k) => setActiveTab(k)}
  //       className="mb-3"
  //       fill
  //     >
  //       <Tab eventKey="principal" title="Monitoreo de la sala en tiempo real">
  //         {reporte_principal !== 'null' ? 
  //           <iframe
  //             title="Monitoreo de la sala en tiempo real"
  //             src={reporte_principal}
  //             width="100%"
  //             height="900"
  //             style={{ border: '0' }}
  //             allowFullScreen
  //             sandbox="allow-forms allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
  //           ></iframe>
  //           : <div style={{width: '100%', textAlign: 'center', padding: '50px'}}>
  //             Este reporte no está configurado. Por favor comuníquese con soporte al correo siteturnos@sitesas.com
  //           </div>
  //         }
  //       </Tab>
  //       <Tab eventKey="secundario" title="Histórico de atención en Sala">
  //         {reporte_secundario !== 'null' ? 
  //           <iframe
  //             title="Histórico de atención en Sala"
  //             src={reporte_secundario}
  //             width="100%"
  //             height="900"
  //             style={{ border: '0' }}
  //             allowFullScreen
  //             sandbox="allow-forms allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
  //           ></iframe>
  //           : <div style={{width: '100%', textAlign: 'center', padding: '50px'}}>
  //             Este reporte no está configurado. Por favor comuníquese con soporte al correo siteturnos@sitesas.com
  //           </div>
  //         }
  //       </Tab>
  //     </Tabs>
  //   </div>
  // );
};

export default Home;
